<template>
    <div class="as_main" @click="showLanguagen = false">
        <div style="overflow: hidden;padding: 10px;box-sizing: border-box; background:#fff;">
            <!--<div class="title-logo"
                 style="background:url(http://cdn.aoshangbao.com.au/cmp/aoshang_logo.jpg) center center no-repeat;background-size:contain"></div>-->
            <div class="mainsearch">
                <van-search placeholder="请输入搜索关键词" v-model="searchValue" @click="onSearch" />
            </div>
            <div class="languagen">
                <div class="title" @click.stop="showLanguagen = !showLanguagen">English <van-icon name="arrow-down" /></div>
                <div class="selects" v-if="showLanguagen">
                    <div class="text" @click="skipLanguagen('zh-Hans')">简体中文</div>
                    <div class="text" @click="skipLanguagen('en')">English</div>
                </div>
            </div>
        </div>
        <!--轮播-->
        <div class="swipe">
            <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(image, index) in images" :key="index">
                    <img :src="image.imageUrl" :alt="image.title"/>
                </van-swipe-item>
            </van-swipe>
        </div>
        <!--菜单-->
        <div class="menu as_icon">
            <van-tabbar v-model="active">
                <van-tabbar-item icon="01" url="/m/so" @click="skipTo('/m/so')">限时特惠</van-tabbar-item>
                <van-tabbar-item icon="02" url="/m/data?categoryId=135&title=火爆热销" @click="skipTo('/m/hot')">火爆热销</van-tabbar-item>
                <van-tabbar-item icon="03" @click="openPopup(1)">商品品牌</van-tabbar-item>
                <van-tabbar-item icon="04" @click="openPopup(2)">分类</van-tabbar-item>
            </van-tabbar>
        </div>
        <!--展示-->
        <div class="Show">
            <div v-if="preferentials.length > 0">
                <van-cell value="更多商品" is-link to="/m/so">
                    <template slot="title">
                        <span class="line"></span>
                        <span>限时特惠</span>
                    </template>
                </van-cell>
                <ul>
                    <li v-for="item in preferentials">
                        <router-link :to="{path: '/m/transaction/' + item.id}">
                            <img :src="item.imageUrl"/>
                            <p class="price_name">{{ item.name }}</p>
                            <p class="price_now">
                                {{ getPriceType(item.priceType).symbol }}{{ item.price }}
                            </p>
                            <p class="price_del"><span v-if="item.originalPrice > item.price">{{ getPriceType(item.priceType).symbol }}{{item.originalPrice}}</span></p>
                        </router-link>
                    </li>
                    <div class="clearb"></div>
                </ul>
            </div>
            <!--<div v-if="false">
                <van-cell value="更多商品" is-link to="/m/hot">
                    <template slot="title">
                        <span class="line"></span>
                        <span>火爆热销</span>
                    </template>
                </van-cell>
                <ul>
                    <li v-for="item in hotSales">
                        <router-link :to="{path: '/m/transaction/' + item.id}">
                            <img :src="item.imageUrl" />
                            <p class="price_name">{{ item.name }}</p>
                            <p class="price_now">
                                {{ getPriceType(item.priceType).symbol }}{{ item.price }}
                            </p>
                            <p class="price_del"><span v-if="item.originalPrice > item.price">{{ getPriceType(item.priceType).symbol }}{{item.originalPrice}}</span></p>
                        </router-link>
                    </li>
                    <div class="clearb"></div>
                </ul>
            </div>-->
            <div v-for="(item, index) in products">
                <van-cell value="更多商品" is-link
                    :to="{path:'/m/data', query:{categoryId:item.category.id, title:item.category.name}}"
                >
                    <template slot="title">
                        <span class="line"></span>
                        <span>{{item.category.name}}</span>
                    </template>
                </van-cell>
                <ul>
                    <li  v-for="pd in item.items">
                        <router-link :to="{path: '/m/transaction/' + pd.id}">
                            <img :src="pd.imageUrl" />
                            <p class="price_name">{{ pd.name }}</p>
                            <p class="price_now">
                                {{ getPriceType(pd.priceType).symbol }}{{ pd.price }}
                            </p>
                            <p class="price_del"><span v-if="pd.originalPrice > pd.price">{{ getPriceType(pd.priceType).symbol }}{{pd.originalPrice}}</span></p>
                        </router-link>
                    </li>
                    <div class="clearb"></div>
                </ul>
            </div>
            <div style="height: 60px"></div>
        </div>
        <brand-or-Categories :showPopup="showPopup" :showBrandOrCate="showBrandOrCate" 
            @closePopup="closePopup"></brand-or-Categories>
    </div>


</template>

<script>
    import BrandOrCategories from '@/views/m/components/brandOrCategories.vue'
    export default {
        name: "Home",
        components: {
            BrandOrCategories
        },
        data() {
            return {
                active: 0,
                searchValue: '',
                images: [],
                params: { page: 1, size: 4 },
                hotSales: [], //火爆热销
                preferentials: [], //限时特惠
                products: [],
                categoriesAndBrands: [],
                showPopup: false,
                showBrandOrCate: 1,
                showLanguagen: false
            };
        },
        watch: {
            "$route.path"(v) {
                this.closePopup()
            }
        },
        mounted() {
            this.getAds()
            this.showLoading()
            this.getHotSales()
            this.getPreferentials()
            this.getCategoriesAndBrands()
            this.getProducts()
        },
        methods: {
            getAds() {
                this.$axios.get(window.consts.apis.allAds+"?platform=2").then(r=>{
                    if(r.success){
                        this.images = r.result;
                    }
                })
            },
            onSearch() {
                this.$router.push({ path:'/m/sort' });
                //location.href = "/m/sort"
                //this.$router.push({ path:'/m/sort', query: { keywords: this.searchValue } });
            },
            onCancel() {
                this.$toast(this.$t('cancel'));
            },
            getHotSales() {
                this.$axios.post(window.consts.apis.hotSale + "?take=6").then(r=>{
                    this.hideLoading()
                    if(r.success){
                        this.hotSales = r.result.items
                    }
                }).catch(e => {
                    this.hideLoading()
                })
            },
            getPreferentials() {
                this.$axios.post(window.consts.apis.preferential + "?take=6").then(r=>{
                    this.hideLoading()
                    if(r.success){
                        this.preferentials = r.result.items
                    }
                }).catch(e => {
                    this.hideLoading()
                })
            },
            getProducts(){
                this.$axios.post(window.consts.apis.categoryItems + "?take=6").then(r=>{
                    this.hideLoading()
                    if(r.success){
                        this.products = r.result;
                    }
                }).catch(e => {
                    this.hideLoading()
                })
            },
            getCategoriesAndBrands () {
                this.$axios.get(window.consts.apis.categoriesAndBrands).then(res => {
                    if (res.success) {
                        this.categoriesAndBrands = res.result;
                    }
                }).catch(e => {
                    this.hideLoading()
                })
            },
            skipTo(link) {
                // this.$router.push({ path: link })
            },
            openPopup(type) {
                this.showBrandOrCate = type;
                this.showPopup = true;
            },
            onNavClick(index) {
                this.mainActiveIndex = index;
                if (this.items.length > 0 && this.items[index].children.length > 0) {
                    this.activeId = this.items[index].children[0].id;
                }
            },
            onItemClick(data) {
                if (this.items.length > 0 && this.items[this.mainActiveIndex].children.length > 0) {
                    this.activeId = this.items[this.mainActiveIndex].children[0].id;
                }
                this.$router.push({path:'/m/so'})
            },
            closePopup(data) {
                this.showPopup = data || false;
            },
            showLoading() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    loadingType: 'spinner',
                    message: '加载中...'
                });
            },
            hideLoading() {
                this.$toast.clear()
            },
            skipLanguagen(param) {
                let backUrl = location.href
                backUrl = decodeURIComponent(backUrl)
                console.log(backUrl)
                if (backUrl.indexOf("?") != -1) {
                    let getRequest = this.getRequest()
                    let languageVal = getRequest["language"]
                    if (languageVal == undefined) {
                        backUrl = backUrl + "&language=" + param
                    } else {
                        let regx = "language=" + languageVal
                        backUrl = backUrl.replace(regx, "language=" + param)
                    }
                } else {
                    backUrl = backUrl + "?language=" + param
                }
                backUrl = backUrl.replace("://")
                let index = backUrl.indexOf("/")
                backUrl = backUrl.substr(index)
                backUrl = encodeURIComponent(backUrl)
                console.log(backUrl)
                let url = "/AbpLocalization/ChangeCulture?cultureName=" + param + "&returnUrl=" + backUrl
                //window.location.replace(url)
                window.location.href = url
            }
        }
    }


</script>

<style scoped lang="scss">
    .title-logo {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 4px;
        padding: 10px 0;
        box-sizing: border-box;
        overflow: hidden;
    }

    .van-search {
        padding: 0;
    }
    .van-swipe{
        height: calc(100vw * 0.44);
    }
    .van-swipe img{
        width: 100%;
        height:100%;
    }
    .menu div{
        position: relative;
        height:80px;
    }
    ::v-deep .menu .van-tabbar-item__icon { 
        font-size: 32px;
        color: #03b5e5;
    }
    .menu .van-tabbar-item--active { 
        color: #03b5e5;
    }
    ::v-deep .menu .van-tabbar-item__text {
        color:#444;
    }
    .van-cell {
        margin-top: 10px;
    }
    .van-cell__title{
        text-align: left;
        font-weight: bold;
    }
    .van-cell:not(:last-child)::after { 
        left:0;
        border-bottom: 0;
    }
    .van-search .van-cell {
        margin:0;
    }
    ::v-deep .as_icon {
        .van-icon {
            display: inline-block;
            width: 32px;
            height: 32px;
        }
        .van-icon-01 {
            background: url("../../../../assets/frontend/images/icon_01.jpg") 0 0 no-repeat;
            background-size: cover;
        }
        .van-icon-02 {
            background: url("../../../../assets/frontend/images/icon_02.jpg") 0 0 no-repeat;
            background-size: cover;
        }
        .van-icon-03 {
            background: url("../../../../assets/frontend/images/icon_03.jpg") 0 0 no-repeat;
            background-size: cover;
        }
        .van-icon-04 {
            background: url("../../../../assets/frontend/images/icon_04.jpg") 0 0 no-repeat;
            background-size: cover;
        }
    }
    .mainsearch {
        width: 75%; 
        float: left;
        .van-search__content {
            border-radius: 20px;
            box-shadow: 0px 0px 5px #d9f5c3;
        }
    }
    .languagen {
        width: 25%;
        height: 32px;
        line-height: 32px;
        float: right;
        font-size: 13px;
        text-align: right;
        position: absolute;
        right: 0px;
        z-index: 1000;
        .title {
            margin-right: 10px;
            .van-icon {
                margin-top: 5px;
            }
        }
        .selects {
            width: 100%;
            background: #ffffff;
        }
        .text {
            height: 32px;
            line-height: 32px;
            border-top: 1px solid #f7f7f7;
            text-align: center;
        }
    }
    ::v-deep .van-swipe__indicator { background-color: #fff; opacity: 1;}
    ::v-deep .van-swipe__indicator:not(:last-child) { margin-right: 3px;}
    ::v-deep .van-swipe__indicator--active { background-color: #fff; width:20px; border-radius:5px;}
    .as_main .Show ul li {
        border-bottom: 1px solid #f8f8f8;
    }
    .as_main .Show ul li:nth-child(odd) {
        border-right: 1px solid #f8f8f8;
    }
    .as_main .line {
        display:inline-block;
        width:3px;
        height: 10px;
        border-radius:8px;
        margin-right: 8px;
        background: #8ac25e;
    }
    .as_main .Show .van-cell__title {
        font-size: 16px;
        flex: 2;
    }
</style>
